import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";

export async function addUserGroup(locationId, authorizedLocation) {
	const query = gql`
		mutation addUserGroup($locationId: String!, $authorizedLocation: String) {
			addUserGroup(locationId: $locationId, authorizedLocation: $authorizedLocation) {
				_id
				locationId
				groupName
				groupDescription
				groupActions
			}
		}
	`;

	const variables = {
		locationId,
		authorizedLocation,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.addUserGroup;
	} catch (err) {
		errorLogger(err);
		return null;
	}
}

export async function addUserGroupAccessActions(locationId, userGroupActions) {
	const query = gql`
		mutation addUserGroupAccessActions($locationId: String!, $input: UserGroupActionsInput) {
			addUserGroupAccessActions(locationId: $locationId, input: $input) {
				_id
				locationId
				actions {
					_id
					actionDescription
					actionKey
					actionName
					category
				}
				users {
					_id
					fullName
					position
				}
			}
		}
	`;

	const variables = {
		locationId,
		input: userGroupActions,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.addUserGroupAccessActions;
	} catch (err) {
		errorLogger(err);
		return null;
	}
}

export async function addUserGroupAccessUsers(locationId, userGroupUsers) {
	const query = gql`
		mutation addUserGroupAccessUsers($locationId: String!, $input: UserGroupUsersInput) {
			addUserGroupAccessUsers(locationId: $locationId, input: $input) {
				_id
				locationId
				users {
					_id
					fullName
					position
					locationId
					locationName
				}
			}
		}
	`;

	const variables = {
		locationId,
		input: userGroupUsers,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.addUserGroupAccessUsers;
	} catch (err) {
		errorLogger(err);
		return null;
	}
}

export async function deleteUserGroup(locationId, groupId, authorizedLocation) {
	const query = gql`
		mutation deleteUserGroup($locationId: String!, $groupId: String!, $authorizedLocation: String) {
			deleteUserGroup(locationId: $locationId, groupId: $groupId, authorizedLocation: $authorizedLocation) {
				_id
				locationId
				groupName
				groupDescription
				groupActions
			}
		}
	`;

	const variables = {
		locationId,
		groupId,
		authorizedLocation,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.deleteUserGroup;
	} catch (err) {
		errorLogger(err);
		return null;
	}
}

export async function deleteUserGroupAccessActions(locationId, userGroupActions) {
	const query = gql`
		mutation deleteUserGroupAccessActions($locationId: String!, $input: UserGroupActionsInput) {
			deleteUserGroupAccessActions(locationId: $locationId, input: $input) {
				_id
				locationId
				actions {
					_id
					actionDescription
					actionKey
					actionName
					category
				}
				users {
					_id
					fullName
					position
					locationId
					locationName
				}
			}
		}
	`;

	const variables = {
		locationId,
		input: userGroupActions,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.deleteUserGroupAccessActions;
	} catch (err) {
		errorLogger(err);
		return null;
	}
}

export async function deleteUserGroupAccessUsers(locationId, userGroupUsers) {
	const query = gql`
		mutation deleteUserGroupAccessUsers($locationId: String!, $input: UserGroupUsersInput) {
			deleteUserGroupAccessUsers(locationId: $locationId, input: $input) {
				_id
				locationId
				users {
					_id
					fullName
					position
					locationId
					locationName
				}
			}
		}
	`;

	const variables = {
		locationId,
		input: userGroupUsers,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.deleteUserGroupAccessUsers;
	} catch (err) {
		errorLogger(err);
		return null;
	}
}

export async function updateUserGroup(locationId, input) {
	const query = gql`
		mutation updateUserGroup($locationId: String!, $input: UserGroupInput) {
			updateUserGroup(locationId: $locationId, input: $input) {
				_id
				locationId
				groupName
				groupDescription
				groupActions
			}
		}
	`;

	const variables = {
		locationId,
		input,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.updateUserGroup;
	} catch (err) {
		throw new Error(err);
	}
}
